'use es6';

// https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods
// The order here will determine the display order for API operations
const Methods = ['GET', 'POST', 'PATCH', 'PUT', 'DELETE', 'HEAD', 'CONNECT', 'OPTIONS', 'TRACE'];
export default Methods;